// extracted by mini-css-extract-plugin
export default {"head":"Form_head__VR51a","title":"Form_title__qJJWK","close":"Form_close__RKC5k","row":"Form_row__gjnH8","col":"Form_col__PZCNk"};